/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { ReactComponent as AirspanLogo } from "../../icons/airspan_stacked_lockup_blue.svg";
import { useSelector } from "react-redux";
import { versionDataSelector } from "../../store/helpers/helperSelectors";
import { basicDialogSelector } from "../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../store/hooks";
import { setBasicDialogOpenFor } from "../../store/helpers/helperReducers";
import { DIALOGOPENFOR } from "../../globals/globals";
import {
  Dialog,
  DialogContent,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Separator } from "../ui/separator";
import { X } from "lucide-react";

const ShowVersion: React.FC = () => {
  const dispatch = useStoreDispatch();
  const versiondata = useSelector(versionDataSelector);
  const basicDialogOpenFor = useSelector(basicDialogSelector);
  const version = versiondata?.version ? versiondata.version.split("#") : ["0"];

  const isOpen = basicDialogOpenFor === DIALOGOPENFOR.APPVERSION;

  const handleClose = () => {
    dispatch(setBasicDialogOpenFor(undefined));
  };

  const handleDownload = () => {
    window.open(require("../../utils/UserGuide.pdf"), "_blank");
  };

  const currentYear = new Date().getFullYear();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) handleClose(); }}>
      <DialogContent className="max-w-sm p-0 bg-card border-border gap-0 flex flex-col items-center">
        <button
          onClick={handleClose}
          className="absolute right-3 top-3 z-10 rounded-sm bg-transparent border-none opacity-70 transition-opacity hover:opacity-100 focus:outline-none text-muted-foreground"
        >
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button>

        <div className="w-full px-8 pt-2 pb-2 flex flex-col items-center text-center">
          <AirspanLogo
            className="[&_.st1]:fill-foreground w-full max-w-[100px] h-auto"
          />

          <h2 className="text-2xl font-bold tracking-tight text-card-foreground mt-3 mb-2">AMS</h2>

          <Separator className="w-full" />

          <p className="uppercase text-sm text-muted-foreground mt-4">version</p>
          <p className="mt-1 mb-2 text-card-foreground">{version[0]}</p>

          <Separator className="w-full" />

          <Button variant="outline" className="mt-6" onClick={handleDownload}>
            Download User Guide
          </Button>

          <p className="mt-6 text-sm text-muted-foreground max-w-[200px]">
            Copyright {currentYear} Airspan<br />
            All rights reserved
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShowVersion;
